import images from "./images";
import {FaWindowMaximize, FaIdCardAlt, FaRocket, FaFileAlt} from "react-icons/fa";
import {BsFileEarmarkLock2} from "react-icons/bs";
import {RiCustomerService2Fill} from "react-icons/ri";
import {SiBlockchaindotcom , SiRobotframework} from "react-icons/si";


const gradient = "url(#blue-gradient)" ;

const services = [
    {
        id: 1,
        icon: <SiBlockchaindotcom style = {{ fill: gradient }} />,
        title: "Blockchain Tech",
        text: "Immutable ledger facilitates  process of recording transactions"
    },
    {
        id: 2,
        icon: <FaWindowMaximize style = {{ fill: gradient }} />,
        title: "Easy of Use",
        text: "Easy to Use UI for everyday documment management"
    },
    {
        id: 3,
        icon: <FaRocket style = {{ fill: gradient }} />,
        title: "Instant traceability",
        text: "identify fake transactions can ease paperwork processing"
    },
    {
        id: 4, 
        icon: <SiRobotframework style = {{ fill: gradient }} />,
        title: "Automation",
        text: "Automation of paperless documentation through AI"
    },
    {
        id: 5,
        icon: <BsFileEarmarkLock2 style = {{ fill: gradient }} />,
        title: "Highly Secure Network",
        text: "Free your data from breaches, intrusions and other threats"
    },
    {
        id: 6,
        icon: <RiCustomerService2Fill style = {{ fill: gradient }} />,
        title: "Service Assitance",
        text: "Lorem ipsum dolor sit mattis amet consectetur adipiscing"
    }
];

const about = [
    {
        id: 7,
        text: "Ensured Data Security through blockchain Technology"
    }
]

const qualities = [
    {
        id: 8,
        icon: <FaFileAlt style = {{ fill: gradient }} />,
        title: "Ideas & Plans",
        text: "Get all your goverment authentication and documents at one place and in the highly secure enviroment"
    },
    {
        id: 9,
        icon: <FaIdCardAlt style = {{ fill: gradient }}  />,
        title: "Single ID for every problem",
        text: "Access all the documents with a single ID"
    }
];

const features = [
    {
        id: 10,
        title: "What is Blockchain ?",
        text: "Blockchain is a shared, immutable ledger that facilitates the process of recording transactions and tracking assets in a business network."
    },
    {
        id: 11,
        title: "How it will enhance security ?",
        text: "Everything that occurs on the blockchain is encrypted and it's possible to prove that data has not been altered. Because of its distributed nature, you can check file signatures across all the ledgers on all the nodes in the network and verify that they haven't been changed."
    },
    {
        id: 12,
        title: "How blockchain actually store data ?",
        text: "Each new block connects to all the blocks before it in a cryptographic chain in such a way that it's nearly impossible to tamper with."
    },
    {
        id: 13,
        title: "How it will be accessible to all ?",
        text: "Through about website or mobile application it will be accssible to all the proud citizens of India."
    }, 
    {
        id: 14,
        title: "How it is better other databases ?",
        text: "Blockchain serves as the distributed database."
    },
    {
        id: 15,
        title: "Which things we will be using for the authentication for the citizens of India ?",
        text: "We will be using the aadhar authentication mechanism for the generation of id which will be later used in the Web3.0 for all the document and policy creations."
    }
];

const portfolio = [
    {
        id: 16,
        title: "Blockchain Database System",
        text: "Blockchain Database System will be used by us to store our data in a secured distributed ledger",
        image: images.portfolio_img_1,
    },
    {
        id: 17,
        title: "Single Id for every document",
        text: "We will be using the big data analytics to automate the big data analytics and ai AI algorithm for checking.",
        image: images.portfolio_img_2,
    },
    {
        id: 18,
        title: "SET Mode ",
        text: "Set Mode is one way queue killer that will reduce the queue lines in the goverment offices.",
        image: images.portfolio_img_3,
    }
];

const testimonials = [
    {
        id: 19,
        name: "Pankaj Acharya",
        text: "Blockchain can digitize the entire trade finance lifecycle with increased security and efficiency.",
        image: images.customer_img_1,
        rating: 3
    },
    {
        id: 20,
        name: "Prashant Thanvi",
        text: "AI BlockChain is a digital ledger that employs intelligent digital agents to govern the chain. ",
        image: images.customer_img_2,
        rating: 5
    },
    {
        id: 21,
        name: "Dipesh Vaya",
        text: "blockchain is to allow digital information to be recorded and distributed, but not edited.",
        image: images.customer_img_3,
        rating: 2
    },
    {
        id: 22,
        name: "Pijush K.D Pramanik",
        text: "Blockchain is certainly one of the best tech careers to choose.",
        image: images.customer_img_4,
        rating: 4
    },
    {
        id: 23,
        name: "Jaya Gangwani",
        text: "By 2022, at least one innovative business built on blockchain technology will be worth $10 billion.",
        image: images.customer_img_5,
        rating: 2
    },
    {
        id: 24,
        name: "Aditya Chajjar",
        text: "A faster business work flow is created as the time wasted on getting signatures on documents is eliminated.",
        image: images.customer_img_6,
        rating: 4
    }
]

const contact = [
    {
        id: 24,
        name: "+91 9511506378",
        text: "Phone Number",
    },
    {
        id: 24,
        name: "networkpaperind@gmail.com",
        text: "Email Address",
    },
    {
        id: 24,
        name: "Jodhpur,rajasthan",
        text: "Company Address",
    }
]

const sections = {services, about, qualities, features, portfolio, testimonials, contact};

export default sections;